import styles from "./uploaded-photos-dialog.module.css";
import { useState } from "react";
import { UploadedPhotosGrid } from "./uploaded-photos-grid";
import { DropdownMenu } from "components/common/dropdown-menu";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";

interface UploadedPhotosDialogProps {
  label?: React.ReactNode;
  onClickImage: (url: string) => void;
}

export const UploadedPhotosDialog = (props: UploadedPhotosDialogProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <DropdownMenu
      label={props.label ?? <FallbackLabel isDialogVisible={isVisible} />}
      alignment={"left"}
      isVisible={isVisible}
      onToggleVisibility={() => {
        setIsVisible((prev) => !prev);
      }}
    >
      <div className={styles.container}>
        <div className={styles.photoGridContainer}>
          <UploadedPhotosGrid
            onLoadURLs={(urls) => {}}
            onClickImage={(url) => {
              setIsVisible((prev) => !prev);
              props.onClickImage(url);
            }}
          />
        </div>
      </div>
    </DropdownMenu>
  );
};

interface FallbackLabelProps {
  isDialogVisible: boolean;
}

const FallbackLabel = (props: FallbackLabelProps) => {
  return (
    <button className={styles.uploadedPhotosButton}>
      <p>Choose from uploaded photos</p>
      <UIIcon
        iconName={props.isDialogVisible ? "CHEVRON-UP" : "CHEVRON-DOWN"}
        variant="SELECTED"
        size={16}
      />
    </button>
  );
};
